module.exports = __webpack_public_path__ + "static/fighting-for-your-marriage-14358b052514fc9eff4a6bb27cf3f9ae.jpg";